// Functions

// Functions: Scrolling

window.disableScrolling = () => {
  if (document.body.hasAttribute('scrolling-disabled')) { return; }

  const scrollY = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = '100%';

  document.body.setAttribute('scrolling-disabled', '');
  document.body.setAttribute('scrolling-y', scrollY);
};

window.enableScrolling = () => {
  if (!document.body.hasAttribute('scrolling-disabled')) { return; }

  const scrollY = parseInt(document.body.getAttribute('scrolling-y') || '0');
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  window.scrollTo(0, scrollY);

  document.body.removeAttribute('scrolling-disabled');
  document.body.removeAttribute('scrolling-y');
};

window.scrollingY = () => {
  if (document.body.hasAttribute('scrolling-disabled')) {
    return parseInt(document.body.getAttribute('scrolling-y') || '0');
  } else {
    return window.scrollY;
  }
};
